import { Component, Input, OnInit } from '@angular/core';
import { Media } from 'src/app/models/service/media';
import { MediaCategory } from 'src/app/models/service/media-category';
import { Solution } from 'src/app/models/service/solution';

@Component({
    selector: 'app-tutorials-documents-view',
    templateUrl: './tutorials-documents-view.component.html',
    styleUrls: ['./tutorials-documents-view.component.scss'],
    standalone: false
})
export class TutorialsDocumentsViewComponent implements OnInit {

  @Input() service: Solution;

  MediaCategory = MediaCategory;

  selected = MediaCategory.DOCUMENT;

  tutorials: Media[];
  documents: Media[];

  filteredTutorials: Media[];
  filteredDocuments: Media[];

  searchValue: string;

  constructor() {
  }

  ngOnInit(): void {
    this.sortMedia();
    this.getTutorialsAndDocuments();
    this.filteredTutorials = [...this.tutorials];
    this.filteredDocuments = [...this.documents];
  }

  /**
   * Handles the selection change
   *
   * @param item - the selected item
   */
  select(item): void {
    this.selected = item;

    //Reset when selection is changed
    if(this.selected === MediaCategory.TUTORIAL) {
      this.filteredDocuments = [...this.documents];
    } else {
      this.filteredTutorials = [...this.tutorials];
    }

    this.search();
  }

  /**
   * Performs a simple search in the list of tutorials/documents
   *
   * @param value - the text to use when filtering
   */
  search(): void {
    const medias = this.selected === MediaCategory.TUTORIAL ? this.filteredTutorials : this.filteredDocuments;

    if (!medias) {
      return;
    }

    if(this.searchValue) {
      const value = this.searchValue.toLowerCase();
      if(this.selected === MediaCategory.TUTORIAL) {
        this.filteredTutorials = this.filter(this.tutorials, value);
      } else {
        this.filteredDocuments = this.filter(this.documents, value);
      }
    } else {
      if(this.selected === MediaCategory.TUTORIAL) {
        this.filteredTutorials = [...this.tutorials];
      } else {
        this.filteredDocuments = [...this.documents];
      }
    }
  }

  /**
   * Filters and prepares tutorials and documents
   */
  private getTutorialsAndDocuments(): void {
    this.tutorials = this.service?.media.filter(media => media.category === MediaCategory.TUTORIAL);
    this.documents = this.service?.media.filter(media => media.category === MediaCategory.DOCUMENT);
  }

  /**
   * Performs a generic filter for tutorials and documents
   *
   * @param list - the list of media to filter
   * @param value - the text to use when filtering
   */
  private filter(list, value): Media[] {
    return list.filter(media =>
      media.name.toLowerCase().includes(value) ||
      media.description.toLowerCase().includes(value));
  }

  /**
   * Sorts the service media in ascending order using the sequence number if present
   *
   * @param firstMedia
   * @param secondMedia
   */
  private sortMedia(): void {
    this.service?.media?.sort((firstMedia, secondMedia) => {
      if (firstMedia.sequenceNumber === undefined && secondMedia.sequenceNumber === undefined) {
        return 0;
      }

      if (firstMedia.sequenceNumber === undefined) {
        return 1;
      }

      if (secondMedia.sequenceNumber === undefined) {
        return -1;
      }

      return firstMedia.sequenceNumber - secondMedia.sequenceNumber;
    });
  }
}
